/**
 * 场景分类导航组件
 * 功能：统一使用 Swiper 实现横向滚动的场景分类导航
 * 
 * 主要特性：
 * - 所有屏幕尺寸统一使用 Swiper 横向滚动
 * - 自动适应内容宽度
 * - 支持响应式自动切换
 * - 窗口 resize 时重新初始化
 */
if (!customElements.get('scenario-rv-navigation')) {
  customElements.define(
    'scenario-rv-navigation',
    class ScenarioRvNavigation extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.resizeTimer = null;
      }

      /**
       * 组件挂载到 DOM 时调用
       */
      connectedCallback() {
        this.init();
        this.addResizeListener();
      }

      /**
       * 组件从 DOM 移除时调用
       * 清理 Swiper 实例和事件监听
       */
      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
        
        // 清理 resize 监听器
        if (this.handleResize) {
          window.removeEventListener('resize', this.handleResize);
        }
      }

      /**
       * 初始化 Swiper
       */
      init() {
        const swiperContainer = this.querySelector('.scenario-rv-navigation__swiper');
        const scrollbar = this.querySelector('.swiper-scrollbar');

        if (!swiperContainer) {
          return;
        }

        // 销毁已存在的实例
        if (this.swiper) {
          this.swiper.destroy(true, true);
        }

        // 确保 Swiper 库已加载
        if (typeof Swiper === 'undefined') {
          console.error('Swiper library is not loaded');
          return;
        }

        // 判断当前是否为小屏幕（< 576px）
        const isSmallScreen = window.innerWidth < 576;

        // 初始化 Swiper - 统一使用横向滚动
        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: isSmallScreen ? 16 : 56,
          scrollbar: {
            el: scrollbar,
            draggable: true,
          },
        });
      }

      /**
       * 添加窗口 resize 监听
       * 使用防抖优化性能
       */
      addResizeListener() {
        this.handleResize = () => {
          // 清除之前的定时器
          clearTimeout(this.resizeTimer);
          
          // 300ms 防抖后重新初始化
          this.resizeTimer = setTimeout(() => {
            this.init();
          }, 300);
        };

        window.addEventListener('resize', this.handleResize);
      }
    }
  );
}
